import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as hostingLogsActions from '../actions/hosting-logs.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadLogs} from '../actions';
import {HostingService} from "../../websites/website/hosting/hosting.service";

@Injectable()
export class HostingLogsEffects {

  loadLogs$ = createEffect(() => this._actions$.pipe(
    ofType(hostingLogsActions.LOAD_LOGS),
    mergeMap((action: LoadLogs) => {
      return this._hostingService.getLogs(action.payload, action.lines, action.logType)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              return new hostingLogsActions.LoadLogsSuccess({
                websiteId: action.payload,
                entities: response.data
              });
            }
            return new hostingLogsActions.LoadLogsFail(response.message);
          })
        );
    })
  ));

  /*@Effect() updateWebsiteSubData$ = this._actions$.ofType(UPDATE_WEBSITE_SUB_DATA)
    .pipe(
      filter((action: UpdateWebsiteSubData) => !!action.payload.domain_hash),
      map((action: UpdateWebsiteSubData) => {
        return new hostingLogsActions.LoadLogs(action.payload.id, 1000, "access");
      })
    );*/

  constructor(
    private _actions$: Actions,
    private _hostingService: HostingService
  ) {
  }


}
